const getTotalCycles = (store) => {
  return store.totalCycles;
};

export { getTotalCycles };
